import type { ReactNode } from 'react';
import { CurrentUserPrefetch } from '@/entities/user';
import { AuthProvider } from '@/shared/components/auth/AuthProvider';
import { UsersProvider } from '@/entities/user';

export interface AuthSessionProvidersProps {
    children: ReactNode;
}

/**
 * Auth + RAM user directory context. Lives in app/providers so bootstrap wiring stays out of main.tsx.
 */
export function AuthSessionProviders({ children }: AuthSessionProvidersProps) {
    return (
        <AuthProvider>
            <CurrentUserPrefetch />
            <UsersProvider>{children}</UsersProvider>
        </AuthProvider>
    );
}
